<template>
  <div id="app" style="min-width:1200px">
    <i v-show="globalLoading" class="my_loading el-icon-loading"></i>
    <router-view/>
  </div>
</template>

<script>
import Vuex from 'vuex'
export default {
  name: 'App',
  computed:{
    ...Vuex.mapState([
      "globalLoading"
    ])
  }
}
</script>

<style scoped>
.my_loading{
  position: fixed;
  top: 50%;
  left: 50%;
  font-size: 30px;
  transform: translate(-50%,-50%);
  -webkit-transform: translate(-50%,-50%);
  -ms-transform: translate(-50%,-50%);
  -moz-transform: translate(-50%,-50%);
  -o-transform: translate(-50%,-50%);
  z-index: 3333;
}
::-webkit-scrollbar {
  width: 10px;
  height: 10px
}
/*定义滚动条轨道*/
::-webkit-scrollbar-track {
  background-color: transparent;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em
}
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  background-color: rgba(186, 186, 186, 0.52);
  background-image: -webkit-linear-gradient(45deg,rgba(255,255,255,.4) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.4) 50%,rgba(255,255,255,.4) 75%,transparent 75%,transparent);
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em
}
</style>




// WEBPACK FOOTER //
// src/App.vue